import { render } from "./AdminPackages.vue?vue&type=template&id=5df0696c"
import script from "./AdminPackages.vue?vue&type=script&lang=js"
export * from "./AdminPackages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__